import ptApiClient from 'plant-api-client';

export function moveFolder(folder, parentId) {
	return ptApiClient.updateFolder(folder._id, { parent_id: parentId }, 'move');
}